import { useState } from "react";
import { Alert, Button } from "@mui/material";

const textoPendentes = (quantidade) =>
  quantidade === 1
    ? "1 crédito não foi lançado na Conta Corrente"
    : `${quantidade} créditos não foram lançados na Conta Corrente`;

/**
 * Aviso exibido depois de aprovar um projeto PIS/COFINS quando a Conta Corrente recusou
 * ou não respondeu a algum crédito. O reenvio usa os mesmos ids no backend, então
 * clicar mais de uma vez não duplica lançamento.
 */
export default function AvisoCreditosPendentes({ pendentes, onReenviar, onFechar }) {
  const [restantes, setRestantes] = useState(pendentes);
  const [reenviando, setReenviando] = useState(false);
  const [erro, setErro] = useState("");

  const reenviar = async () => {
    setReenviando(true);
    setErro("");
    try {
      const resultado = await onReenviar();
      setRestantes(Number(resultado?.pendentes ?? 0));
    } catch (e) {
      setErro(
        e?.response?.data?.mensagem || e?.message || "Não foi possível reenviar os créditos."
      );
    } finally {
      setReenviando(false);
    }
  };

  if (restantes === 0) {
    return (
      <Alert
        severity="success"
        action={
          <Button color="inherit" size="small" onClick={onFechar}>
            Fechar
          </Button>
        }
      >
        Créditos lançados na Conta Corrente.
      </Alert>
    );
  }

  return (
    <Alert
      severity="warning"
      action={
        <>
          <Button color="inherit" size="small" disabled={reenviando} onClick={reenviar}>
            Reenviar créditos
          </Button>
          <Button color="inherit" size="small" disabled={reenviando} onClick={onFechar}>
            Fechar
          </Button>
        </>
      }
    >
      Projeto aprovado, mas {textoPendentes(restantes)}.
      {erro ? ` ${erro}` : ""}
    </Alert>
  );
}
